var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgDisplayMediumCustomSpeedometer = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h17v17H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#7A8E96",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.5 4.42c.188 0 .34-.122.34-.272v-.816c0-.15-.152-.272-.34-.272-.188 0-.34.122-.34.272v.816c0 .15.152.272.34.272zM10.977 5.683a.33.33 0 0 0 .466 0l.7-.7a.33.33 0 0 0-.466-.466l-.7.7a.33.33 0 0 0 0 .466zM12.24 8.5c0 .188.122.34.272.34h.816c.15 0 .272-.152.272-.34 0-.188-.122-.34-.272-.34h-.816c-.15 0-.272.152-.272.34zM5.683 5.683a.33.33 0 0 1-.466 0l-.7-.7a.33.33 0 0 1 .466-.466l.7.7a.33.33 0 0 1 0 .466zM4.42 8.5c0 .188-.122.34-.272.34h-.816c-.15 0-.272-.152-.272-.34 0-.188.122-.34.272-.34h.816c.15 0 .272.152.272.34zM6.8 5.44s.406 2.813.625 3.246c.22.432.77.616 1.23.41.46-.208.654-.726.435-1.158C8.87 7.505 6.8 5.44 6.8 5.44z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 1.7c-3.75 0-6.8 3.05-6.8 6.8s3.05 6.8 6.8 6.8 6.8-3.05 6.8-6.8-3.05-6.8-6.8-6.8zm-5.74 9.165a6.209 6.209 0 1 1 11.479 0H2.761z"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDisplayMediumCustomSpeedometer);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/display-medium-custom-speedometer.837509adce7a14dc57bcad1561c615cc.svg";